import type { MessageDescriptor } from "@lingui/core";
import { msg } from "@lingui/core/macro";

import type { FriendsMetric } from "./FRIENDS_METRICS";

// Названия показателей таблицы: кнопки сортировки и заголовок колонки.
export const METRIC_LABELS: Record<FriendsMetric, MessageDescriptor> = {
  score: msg`Overall score`,
  winRate: msg`Win rate`,
  kda: msg`KDA`,
  soulsPerMinute: msg`Souls per minute`,
  deaths: msg`Deaths`,
  rank: msg`Rank`,
  matches: msg`Matches`,
};

// Что значит показатель — подпись под кнопками.
export const METRIC_HINTS: Record<FriendsMetric, MessageDescriptor> = {
  score: msg`Average quick score of matches out of 100: farm, aggression, teamwork and survival against players of the same rank on the same hero.`,
  winRate: msg`Share of wins in regular matches.`,
  kda: msg`(kills + assists) / deaths over the period.`,
  soulsPerMinute: msg`How many souls a minute of play brings.`,
  deaths: msg`Average deaths per match. Fewer is better.`,
  rank: msg`Rank after the latest ranked match.`,
  matches: msg`Regular matches played in the period.`,
};
